var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M19.5 17.083a1.25 1.25 0 0 1-1.25-1.25v-4.051a6.63 6.63 0 0 0-5.417-6.721V3.333a.833.833 0 1 0-1.667 0v1.728a6.63 6.63 0 0 0-5.417 6.72v4.052a1.25 1.25 0 0 1-1.25 1.25.833.833 0 1 0 0 1.667h15a.833.833 0 1 0 0-1.667ZM13.863 20h-3.727a.208.208 0 0 0-.207.185 2.083 2.083 0 1 0 4.14 0 .207.207 0 0 0-.206-.185Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderBell);
export default __webpack_public_path__ + "static/media/reminder-bell.9d12ce7775c88fce3da9b79821ad1f93.svg";
export { ForwardRef as ReactComponent };